export default {"src":"/_next/static/media/visuals.61219336.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};